import { useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import UseFlowChartContext from './UseFlowChartContext';

export const useFlowChart = () => {
  const context = useContext(UseFlowChartContext);

  /* istanbul ignore next */
  if (isEmpty(context) && process.env.NODE_ENV === 'development') {
    throw new Error('useFlowChart must be used within the `FlowChart` component');
  }

  return context;
};
